export default string => string.replace(/[^\d]/g, "");
